import React from 'react';
import { ModalButton } from 'baseui/modal';
import { KIND as ButtonKind, SIZE as ButtonSize } from 'baseui/button';
import { useStyletron } from 'baseui';

interface RelayActionButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  icon?: React.ReactNode;
  testId?: string;
  width?: string;
}

export const RelayActionButton: React.FC<RelayActionButtonProps> = ({
  children,
  onClick,
  disabled = false,
  icon,
  testId,
  width,
}) => {
  const [css] = useStyletron();

  return (
    <ModalButton
      disabled={disabled}
      size={ButtonSize.mini}
      kind={ButtonKind.secondary}
      endEnhancer={
        icon && (
          <div className={css({ display: 'flex', alignItems: 'center' })}>
            <div
              className={css({
                marginRight: '8px',
                height: '20px',
                width: '1px',
                backgroundColor: '#427a9d',
              })}
            ></div>
            {icon}
          </div>
        )
      }
      autoFocus={false}
      overrides={{
        BaseButton: {
          style: {
            fontFamily: 'DIN Condensed, sans-serif',
            fontSize: '14px',
            lineHeight: '1',
            height: '35px',
            width: width || 'auto',
            color: 'white',
            backgroundColor: '#3693bf',
            outline: '#427a9d 1px solid',
            fontWeight: '400',
            textTransform: 'uppercase',
            borderRadius: '4px',
            borderColor: '#5b5a5999',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ':hover': {
              backgroundColor: '#3FA9DD',
            },
          },
          props: {
            'data-testid': testId,
          },
        },
      }}
      onClick={onClick}
    >
      {children}
    </ModalButton>
  );
};
